import { render, staticRenderFns } from "./MyName.vue?vue&type=template&id=0c264f72&lang=pug&"
import script from "./MyName.vue?vue&type=script&lang=js&"
export * from "./MyName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports